/**
 * Alpine-based toast notifications.
 *
 * Сохраняет публичный API старого toast-helper.js:
 *   window.showToast(type, message, duration)
 *   window.showSuccessToast / showErrorToast / showWarningToast / showInfoToast
 *
 * Разметка контейнера: <div x-data x-init="$store.toasts.init()" ... см. custom-toast.blade.php>
 * Store `toasts` держит массив { id, type, message } и методы show/remove.
 */

import Alpine from 'alpinejs';

const VALID_TYPES = ['success', 'error', 'warning', 'info'];

Alpine.store('toasts', {
    items: [],
    nextId: 1,

    show(type, message, duration = 5000) {
        if (!VALID_TYPES.includes(type)) type = 'info';
        const id = this.nextId++;
        this.items.push({ id, type, message });
        if (duration > 0) {
            setTimeout(() => this.remove(id), duration);
        }
        return id;
    },

    remove(id) {
        const idx = this.items.findIndex(t => t.id === id);
        if (idx !== -1) this.items.splice(idx, 1);
    },
});

// Публичный API — совместимость со старым toast-helper.js
window.showToast = (type, message, duration) => Alpine.store('toasts').show(type, message, duration);
window.showSuccessToast = (message, duration) => window.showToast('success', message, duration);
window.showErrorToast = (message, duration) => window.showToast('error', message, duration);
window.showWarningToast = (message, duration) => window.showToast('warning', message, duration);
window.showInfoToast = (message, duration) => window.showToast('info', message, duration);
